"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const security_error_1 = require("./security-error");
class TwingSandboxSecurityNotAllowedFunctionError extends security_error_1.TwingSandboxSecurityError {
    constructor(message, functionName, lineno = -1, filename = null) {
        super(message, lineno, filename);
        this.functionName = functionName;
        this.name = 'TwingSandboxSecurityNotAllowedFunctionError';
    }
    getFunctionName() {
        return this.functionName;
    }
}
exports.TwingSandboxSecurityNotAllowedFunctionError = TwingSandboxSecurityNotAllowedFunctionError;
